/**
 * Generated by orval v8.12.1 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch";
import type {
	CreateZone400,
	CreateZone403,
	CreateZone500,
	DeleteZone400,
	DeleteZone404,
	DeleteZone500,
	GetZone400,
	GetZone404,
	GetZone500,
	ListZones500,
	UpdateZone400,
	UpdateZone403,
	UpdateZone404,
	UpdateZone500,
	Zone,
	ZoneCreate,
	ZoneUpdate,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListZonesUrl = () => {
	return `/zones`;
};

/**
 * @summary List all zones for the authenticated user
 */
export const listZones = async (options?: RequestInit): Promise<Zone[]> => {
	return customFetch<Zone[]>(getListZonesUrl(), {
		...options,
		method: "GET",
	});
};

export const getListZonesQueryKey = () => {
	return ["zones"] as const;
};

export const getListZonesQueryOptions = <
	TData = Awaited<ReturnType<typeof listZones>>,
	TError = ListZones500,
>(options?: {
	query?: Partial<
		UseQueryOptions<Awaited<ReturnType<typeof listZones>>, TError, TData>
	>;
	request?: SecondParameter<typeof customFetch>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListZonesQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listZones>>> = ({
		signal,
	}) => listZones({ signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listZones>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListZonesQueryResult = NonNullable<
	Awaited<ReturnType<typeof listZones>>
>;
export type ListZonesQueryError = ListZones500;

export function useListZones<
	TData = Awaited<ReturnType<typeof listZones>>,
	TError = ListZones500,
>(
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listZones>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listZones>>,
					TError,
					Awaited<ReturnType<typeof listZones>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListZones<
	TData = Awaited<ReturnType<typeof listZones>>,
	TError = ListZones500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listZones>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listZones>>,
					TError,
					Awaited<ReturnType<typeof listZones>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListZones<
	TData = Awaited<ReturnType<typeof listZones>>,
	TError = ListZones500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listZones>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all zones for the authenticated user
 */

export function useListZones<
	TData = Awaited<ReturnType<typeof listZones>>,
	TError = ListZones500,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof listZones>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListZonesQueryOptions(options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List all zones for the authenticated user
 */
export const useSetListZonesQueryData = () => {
	const queryClient = useQueryClient();
	return (
		updater:
			| Awaited<ReturnType<typeof listZones>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listZones>> | undefined,
			  ) => Awaited<ReturnType<typeof listZones>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof listZones>>>(
			{ queryKey: getListZonesQueryKey() },
			updater,
		);
	};
};

/**
 * @summary List all zones for the authenticated user
 */
export const useGetListZonesQueryData = () => {
	const queryClient = useQueryClient();
	return () =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listZones>>>(
			getListZonesQueryKey(),
		);
};

export const getCreateZoneUrl = () => {
	return `/zones`;
};

/**
 * @summary Create a new zone
 */
export const createZone = async (
	zoneCreate: ZoneCreate,
	options?: RequestInit,
): Promise<Zone> => {
	return customFetch<Zone>(getCreateZoneUrl(), {
		...options,
		method: "POST",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(zoneCreate),
	});
};

export const getCreateZoneMutationOptions = <
	TError = CreateZone400 | CreateZone403 | CreateZone500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof createZone>>,
		TError,
		{ data: ZoneCreate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof createZone>>,
	TError,
	{ data: ZoneCreate },
	TContext
> => {
	const mutationKey = ["createZone"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createZone>>,
		{ data: ZoneCreate }
	> = (props) => {
		const { data } = props ?? {};

		return createZone(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateZoneMutationResult = NonNullable<
	Awaited<ReturnType<typeof createZone>>
>;
export type CreateZoneMutationBody = ZoneCreate;
export type CreateZoneMutationError =
	| CreateZone400
	| CreateZone403
	| CreateZone500;

/**
 * @summary Create a new zone
 */
export const useCreateZone = <
	TError = CreateZone400 | CreateZone403 | CreateZone500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof createZone>>,
			TError,
			{ data: ZoneCreate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof createZone>>,
	TError,
	{ data: ZoneCreate },
	TContext
> => {
	return useMutation(getCreateZoneMutationOptions(options), queryClient);
};
export const getGetZoneUrl = (zoneId: string) => {
	return `/zones/${zoneId}`;
};

/**
 * @summary Get a single zone by ID
 */
export const getZone = async (
	zoneId: string,
	options?: RequestInit,
): Promise<Zone> => {
	return customFetch<Zone>(getGetZoneUrl(zoneId), {
		...options,
		method: "GET",
	});
};

export const getGetZoneQueryKey = (zoneId: string) => {
	return ["zones", zoneId] as const;
};

export const getGetZoneQueryOptions = <
	TData = Awaited<ReturnType<typeof getZone>>,
	TError = GetZone400 | GetZone404 | GetZone500,
>(
	zoneId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetZoneQueryKey(zoneId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getZone>>> = ({
		signal,
	}) => getZone(zoneId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: zoneId !== null && zoneId !== undefined,
		...queryOptions,
	} as UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData> & {
		queryKey: DataTag<QueryKey, TData, TError>;
	};
};

export type GetZoneQueryResult = NonNullable<
	Awaited<ReturnType<typeof getZone>>
>;
export type GetZoneQueryError = GetZone400 | GetZone404 | GetZone500;

export function useGetZone<
	TData = Awaited<ReturnType<typeof getZone>>,
	TError = GetZone400 | GetZone404 | GetZone500,
>(
	zoneId: string,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getZone>>,
					TError,
					Awaited<ReturnType<typeof getZone>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetZone<
	TData = Awaited<ReturnType<typeof getZone>>,
	TError = GetZone400 | GetZone404 | GetZone500,
>(
	zoneId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getZone>>,
					TError,
					Awaited<ReturnType<typeof getZone>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetZone<
	TData = Awaited<ReturnType<typeof getZone>>,
	TError = GetZone400 | GetZone404 | GetZone500,
>(
	zoneId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single zone by ID
 */

export function useGetZone<
	TData = Awaited<ReturnType<typeof getZone>>,
	TError = GetZone400 | GetZone404 | GetZone500,
>(
	zoneId: string,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetZoneQueryOptions(zoneId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get a single zone by ID
 */
export const useSetGetZoneQueryData = () => {
	const queryClient = useQueryClient();
	return (
		zoneId: string,
		updater:
			| Awaited<ReturnType<typeof getZone>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getZone>> | undefined,
			  ) => Awaited<ReturnType<typeof getZone>> | undefined),
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getZone>>>(
			{ queryKey: getGetZoneQueryKey(zoneId) },
			updater,
		);
	};
};

/**
 * @summary Get a single zone by ID
 */
export const useGetGetZoneQueryData = () => {
	const queryClient = useQueryClient();
	return (zoneId: string) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getZone>>>(
			getGetZoneQueryKey(zoneId),
		);
};

export const getUpdateZoneUrl = (zoneId: string) => {
	return `/zones/${zoneId}`;
};

/**
 * @summary Update an existing zone
 */
export const updateZone = async (
	zoneId: string,
	zoneUpdate: ZoneUpdate,
	options?: RequestInit,
): Promise<Zone> => {
	return customFetch<Zone>(getUpdateZoneUrl(zoneId), {
		...options,
		method: "PATCH",
		headers: { "Content-Type": "application/json", ...options?.headers },
		body: JSON.stringify(zoneUpdate),
	});
};

export const getUpdateZoneMutationOptions = <
	TError = UpdateZone400 | UpdateZone403 | UpdateZone404 | UpdateZone500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof updateZone>>,
		TError,
		{ zoneId: string; data: ZoneUpdate },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof updateZone>>,
	TError,
	{ zoneId: string; data: ZoneUpdate },
	TContext
> => {
	const mutationKey = ["updateZone"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateZone>>,
		{ zoneId: string; data: ZoneUpdate }
	> = (props) => {
		const { zoneId, data } = props ?? {};

		return updateZone(zoneId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateZoneMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateZone>>
>;
export type UpdateZoneMutationBody = ZoneUpdate;
export type UpdateZoneMutationError =
	| UpdateZone400
	| UpdateZone403
	| UpdateZone404
	| UpdateZone500;

/**
 * @summary Update an existing zone
 */
export const useUpdateZone = <
	TError = UpdateZone400 | UpdateZone403 | UpdateZone404 | UpdateZone500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof updateZone>>,
			TError,
			{ zoneId: string; data: ZoneUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof updateZone>>,
	TError,
	{ zoneId: string; data: ZoneUpdate },
	TContext
> => {
	return useMutation(getUpdateZoneMutationOptions(options), queryClient);
};
export const getDeleteZoneUrl = (zoneId: string) => {
	return `/zones/${zoneId}`;
};

/**
 * @summary Delete a zone
 */
export const deleteZone = async (
	zoneId: string,
	options?: RequestInit,
): Promise<Zone> => {
	return customFetch<Zone>(getDeleteZoneUrl(zoneId), {
		...options,
		method: "DELETE",
	});
};

export const getDeleteZoneMutationOptions = <
	TError = DeleteZone400 | DeleteZone404 | DeleteZone500,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof deleteZone>>,
		TError,
		{ zoneId: string },
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof deleteZone>>,
	TError,
	{ zoneId: string },
	TContext
> => {
	const mutationKey = ["deleteZone"];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteZone>>,
		{ zoneId: string }
	> = (props) => {
		const { zoneId } = props ?? {};

		return deleteZone(zoneId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteZoneMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteZone>>
>;

export type DeleteZoneMutationError =
	| DeleteZone400
	| DeleteZone404
	| DeleteZone500;

/**
 * @summary Delete a zone
 */
export const useDeleteZone = <
	TError = DeleteZone400 | DeleteZone404 | DeleteZone500,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof deleteZone>>,
			TError,
			{ zoneId: string },
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof deleteZone>>,
	TError,
	{ zoneId: string },
	TContext
> => {
	return useMutation(getDeleteZoneMutationOptions(options), queryClient);
};
